import {APICore} from "./apiCore";

const api = new APICore();
const baseUrl = "/agent-api/request";

function get(request_id: number, params: any) {
    return api.get(`${baseUrl}/${request_id}`, params);
}

function updateStatus(request_id: number, params: any) {
    return api.create(`${baseUrl}/${request_id}/change-status`, params);
}

async function getOfferPackage( offerPackageId: number, params?: any) {
    return api.get(`${baseUrl}/offer-package/${offerPackageId}`, params);
}

async function createOfferPackage(requestId: number, params: any) {
    return api.create(`${baseUrl}/${requestId}/offer-package`, params);
}

export {get, getOfferPackage, updateStatus, createOfferPackage};
